// extracted by mini-css-extract-plugin
export default {"contant":"PropriteBlock_contant__q00C9"};